import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { AutoCompleteModule } from 'primeng/autocomplete';

import { TargetInputComponent } from './target-input.component';

/**
 * Link/button target field with a picker over known site addresses (#199).
 * Its own module so the menus editor and the sections editor can both use it
 * without one pulling in the other.
 */
@NgModule({
  declarations: [TargetInputComponent],
  imports: [CommonModule, FormsModule, AutoCompleteModule],
  exports: [TargetInputComponent],
})
export class TargetInputModule {}
